import { createSlice } from '@reduxjs/toolkit';
import { getContentThunk, getHistoryThunk } from "../../../../shared/model";
import { updateQuickReplies } from "./utils";
var initialState = {
  FeatureTogglesWeb: null,
  FrequentQuestions: null,
  TextMainScreen: null,
  SystemProblemInternet: null,
  ShowAttachments: false,
  filterNotificationChat: null,
  quickReplies: [],
  imageUrlGroup: null,
  dynamicFormHeight: 'auto'
};
export var contentSlice = createSlice({
  name: 'content',
  initialState: initialState,
  reducers: {
    addQuickReplies: function addQuickReplies(state, action) {
      var list = action.payload || [];
      state.quickReplies = list;
    },
    addStoreImageUrlGroup: function addStoreImageUrlGroup(state, _ref) {
      var payload = _ref.payload;
      state.imageUrlGroup = payload;
    },
    addStoreDynamicFormHeight: function addStoreDynamicFormHeight(state, _ref2) {
      var payload = _ref2.payload;
      state.dynamicFormHeight = payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getContentThunk.fulfilled, function (state, _ref3) {
      var payload = _ref3.payload;
      var _payload$data = payload.data,
        FeatureTogglesWeb = _payload$data.FeatureTogglesWeb,
        FrequentQuestions = _payload$data.FrequentQuestions,
        filterNotificationChat = _payload$data.filterNotificationChat,
        SystemProblemInternet = _payload$data.SystemProblemInternet,
        TextMainScreen = _payload$data.TextMainScreen,
        ShowAttachments = _payload$data.ShowAttachments;
      state.FeatureTogglesWeb = FeatureTogglesWeb;
      state.FrequentQuestions = FrequentQuestions;
      state.filterNotificationChat = filterNotificationChat;
      state.SystemProblemInternet = SystemProblemInternet;
      state.TextMainScreen = TextMainScreen;
      state.ShowAttachments = ShowAttachments;
    }).addCase(getHistoryThunk.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      state.quickReplies = updateQuickReplies(payload);
    });
  }
});
var _contentSlice$actions = contentSlice.actions,
  addQuickReplies = _contentSlice$actions.addQuickReplies,
  addStoreImageUrlGroup = _contentSlice$actions.addStoreImageUrlGroup,
  addStoreDynamicFormHeight = _contentSlice$actions.addStoreDynamicFormHeight;
export { addQuickReplies, addStoreImageUrlGroup, addStoreDynamicFormHeight };